/**
 * 素材モーダルから削除したあとに表示する素材を選ぶ。
 *
 * 削除直後の一覧は再取得 (invalidate) がまだ終わっておらず削除した素材を含んでいる想定で、
 * 除外後リストの「同じ位置」= 次の素材になる。末尾を削除したときは 1 つ前に送る。
 * 再取得が先に終わって一覧から消えている場合は fallbackIndex (最後に把握していた位置) を使う。
 *
 * @returns 次に表示する素材と、除外後リストでのその位置。残りが無ければ null (呼び出し側で閉じる)
 */
export function pickNextMaterialAfterDelete<T extends { id: string }>(
  materials: T[],
  deletedId: string,
  fallbackIndex: number | null,
): { material: T; index: number } | null {
  const remaining = materials.filter((mat) => mat.id !== deletedId);
  if (!remaining.length) return null;

  const deletedIndex = materials.findIndex((mat) => mat.id === deletedId);
  const baseIndex = deletedIndex >= 0 ? deletedIndex : (fallbackIndex ?? 0);
  const index = Math.min(Math.max(baseIndex, 0), remaining.length - 1);
  const material = remaining[index];
  if (!material) return null;

  return { material, index };
}
